export default __webpack_public_path__ + "static/media/Step-2.37ee02f0.webm";